__turbopack_context__.v({
  "chevron": "KkUQPa_chevron",
  "chevronOpen": "KkUQPa_chevronOpen",
  "dropdown": "KkUQPa_dropdown",
  "dropdownFadeIn": "KkUQPa_dropdownFadeIn",
  "dropdownItem": "KkUQPa_dropdownItem",
  "icon": "KkUQPa_icon",
  "label": "KkUQPa_label",
  "markdownButton": "KkUQPa_markdownButton",
  "markdownButtonContainer": "KkUQPa_markdownButtonContainer",
});
